module.exports = __webpack_public_path__ + "static/8-kit-48f9704f03c3a411b34398c04e75b5f9.jpg";